import type { CheckoutStore } from './interfaces'
import type { Order } from '@brighterly/lib-core-types/orders/interfaces'

import { getOrder } from './active-order'

export const oneTimePaymentGetters = {
  getOrderTotal: (state: CheckoutStore): Order['total'] => getOrder(state)?.total || 0,
}
